module.exports = __webpack_public_path__ + "static/media/mapInfo.935f271a.csv";